import Login from "@/modules/login/components/login"

export default function LoginPage() {
  return <Login />
}
